import React from 'react';
import { useApp } from '../hooks/useApp';

function NotificationSettings() {
  const { notifications } = useApp();
  const { permission, testNotification } = notifications;

  // Since we're using modal notifications, always show as enabled
  return (
    <div className="inline-flex items-center space-x-2">
      <div className="inline-flex items-center text-sm text-green-600">
        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
      </div>
      
      {/* Temporary test button - remove in production */}
      {import.meta.env.MODE === 'development' && (
        <button
          onClick={testNotification}
          className="inline-flex items-center px-2 py-1 text-xs bg-yellow-100 text-yellow-800 rounded hover:bg-yellow-200 transition-colors"
          title="Test notification modal"
        >
          Test
        </button>
      )}
    </div>
  );
}

export default NotificationSettings;